import React, { useState, useEffect, useCallback } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../Context/auth'; // Ajuste o caminho
import MenuLateral from '../Components/MenuPrincipal/MenuLateral'; // Ajuste o caminho
import '../Marcas/Marcas.css'; // Reutiliza CSS

function EditarEtapaProducao() {
    const { currentUser } = useAuth();
    const navigate = useNavigate();
    const { id } = useParams(); // ID da etapa a ser editada

    const [descricao, setDescricao] = useState('');
    const [sequencia, setSequencia] = useState(''); // Estado para sequência
    const [loadingData, setLoadingData] = useState(true); // Loading para busca inicial
    const [loadingSubmit, setLoadingSubmit] = useState(false); // Loading para submit
    const [mensagem, setMensagem] = useState('');

    // Hook genérico para chamadas API
    const apiCall = useCallback(async (url, method = 'GET', data = null) => {
        if (!currentUser) throw new Error("Usuário não autenticado.");
        const token = await currentUser.getIdToken();
        const API_URL = process.env.REACT_APP_API_URL;
        const config = {
            method,
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
        };
        if (data && method !== 'GET') config.body = JSON.stringify(data);
        const response = await fetch(`${API_URL}${url}`, config);
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.error || `Falha na requisição para ${url}`);
        }
        if (response.status === 204) return null;
        return response.json();
    }, [currentUser]);

    // Busca dados da etapa ao carregar
    useEffect(() => {
        const fetchEtapa = async () => {
            if (!id || !currentUser) { setLoadingData(false); return; } // Verifica ID e usuário
            setLoadingData(true);
            try {
                const data = await apiCall(`/api/etapas-producao/${id}`);
                setDescricao(data.descricao || '');
                setSequencia(data.sequencia !== null ? String(data.sequencia) : ''); // Converte para string
            } catch (error) {
                console.error("Erro ao buscar etapa:", error);
                setMensagem(error.message || "Etapa não encontrada ou erro na busca.");
                // Opcional: Redirecionar após um tempo se não encontrar
                // setTimeout(() => navigate('/app/etapas-producao'), 3000);
            } finally {
                setLoadingData(false);
            }
        };
        fetchEtapa();
    }, [id, currentUser, apiCall, navigate]); // Adiciona navigate

    // Handler para submeter a atualização
    const handleSubmit = async (e) => {
        e.preventDefault();
        setMensagem('');

        if (!descricao || sequencia === '') {
            setMensagem("Os campos Descrição e Sequência são obrigatórios.");
            return;
        }
        if (isNaN(parseInt(sequencia))) {
            setMensagem("O campo Sequência deve ser um número.");
            return;
        }

        setLoadingSubmit(true);
        try {
            await apiCall(`/api/etapas-producao/${id}`, 'PUT', {
                descricao: descricao.trim(),
                sequencia: parseInt(sequencia) // Envia como número
            });
            navigate('/app/etapas-producao'); // Volta para a lista
        } catch (error) {
            console.error("Erro ao atualizar etapa: ", error);
            setMensagem(error.message); // Exibe erro da API (ex: duplicado)
        } finally {
            setLoadingSubmit(false);
        }
    };

    // Renderização Loading inicial
    // Renderização Loading inicial
    if (loadingData) {
        return (
            <div className="form-page-container" style={{ display: 'flex', paddingTop: 0 }}>
                <MenuLateral />
                <div className="d-flex justify-content-center align-items-center w-100" style={{ marginTop: '100px' }}>
                    <div className="spinner-border text-primary" role="status"><span className="visually-hidden">Carregando...</span></div>
                </div>
            </div>
        );
    }
    // Renderização se não encontrou a etapa
    if (!loadingData && !descricao && mensagem) {
        return (
            <div className="form-page-container" style={{ display: 'flex', paddingTop: 0 }}>
                <MenuLateral />
                <div className="content-with-sidebar">
                    <div className="page-header mt-4 mb-3 px-4"><h1 className="page-title mb-0">Erro</h1></div>
                    <div className="form-card-container"><div className="alert alert-danger">{mensagem}</div></div>
                </div>
            </div>
        );
    }


    // Renderização do formulário
    return (
        <div className="marcas-page-container" style={{ display: 'flex', paddingTop: 0 }}>
            <MenuLateral />
            <div className="content-with-sidebar">
                <div className="marcas-header">
                    <div className="d-flex align-items-center gap-3">
                        <button className="btn btn-link text-secondary p-0" onClick={() => navigate('/app/etapas-producao')} title="Voltar">
                            <i className="fas fa-arrow-left fa-lg"></i>
                        </button>
                        <h1 className="marcas-title m-0">
                            Editar <span className="highlight">Etapa de Produção</span>
                        </h1>
                    </div>
                </div>

                <main className="marcas-content">
                    {mensagem && !loadingData && (
                        <div className="alert alert-danger d-flex align-items-center mb-4" role="alert">
                            <i className="fas fa-exclamation-circle me-2"></i>
                            <div>{mensagem}</div>
                        </div>
                    )}

                    {loadingData ? (
                        <div className="text-center p-5">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Carregando...</span>
                            </div>
                        </div>
                    ) : (
                        <form onSubmit={handleSubmit}>
                            <div className="form-card">
                                <h5 className="form-section-header">Informações da Etapa</h5>
                                <div className="row g-3">
                                    {/* Campo Sequência */}
                                    <div className="col-md-3">
                                        <label htmlFor="sequencia" className="form-label-custom">Sequência *</label>
                                        <input
                                            type="number"
                                            className="form-control form-control-custom"
                                            id="sequencia"
                                            value={sequencia}
                                            onChange={(e) => setSequencia(e.target.value)}
                                            required
                                            min="1"
                                        />
                                    </div>
                                    {/* Campo Descrição */}
                                    <div className="col-md-9">
                                        <label htmlFor="descricao" className="form-label-custom">Descrição *</label>
                                        <input
                                            type="text"
                                            className="form-control form-control-custom"
                                            id="descricao"
                                            value={descricao}
                                            onChange={(e) => setDescricao(e.target.value)}
                                            required
                                            autoFocus
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* FIXED FOOTER Actions */}
                            <div className="form-actions-bar">
                                <Link to="/app/etapas-producao" className="btn-secondary-custom">
                                    Cancelar
                                </Link>
                                <button type="submit" className="btn-primary-custom" disabled={loadingSubmit}>
                                    {loadingSubmit ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                            Atualizando...
                                        </>
                                    ) : 'Salvar Alterações'}
                                </button>
                            </div>
                        </form>
                    )}
                </main>
            </div>
        </div>
    );
}

export default EditarEtapaProducao;
